export function createEmptyMediaStream(): MediaStream {
  const canvas = document.createElement('canvas')
  canvas.getContext('2d') // Important for Firefox
  const stream = (canvas as any).captureStream()
  const track = stream.getVideoTracks()[0]
  track.enabled = false
  return new MediaStream([track])
}
